module.exports = __webpack_public_path__ + "img/dynamic5.74689a61.png";